import { Link } from "@inertiajs/react"
import { ChevronRight } from "lucide-react"
import AppLayout from "@/components/AppLayout"
import PageTitle from "@/components/PageTitle"
import { buildAdminLinks } from "@/components/layout/navLinks"

// Internal pages, Super Admins only (AdminController).
export default function AdminIndex() {
  const links = buildAdminLinks()

  return (
    <AppLayout header={<PageTitle title="Admin" subtitle="Internal pages, for Super Admins only" />}>
      <div className="max-w-3xl rounded-lg border border-border bg-card divide-y divide-border">
        {links.map((link) => {
          const Icon = link.icon
          return (
            <Link
              key={link.label}
              href={link.href}
              className="flex items-center gap-3 px-4 py-3 hover:bg-muted"
            >
              {Icon && <Icon size={16} className="text-muted-foreground flex-shrink-0" />}
              <div className="flex-1">
                <p className="text-sm font-medium text-foreground">{link.label}</p>
                {link.description && <p className="text-xs text-muted-foreground">{link.description}</p>}
              </div>
              <ChevronRight size={16} className="text-muted-foreground flex-shrink-0" />
            </Link>
          )
        })}
      </div>
    </AppLayout>
  )
}
